module.exports = __webpack_public_path__ + "static/media/two_ics.8f3bdc15.svg";